export default {"src":"/_next/static/media/XLTX.a6d7f478.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};